import { registerAction } from '../../Action'

const WORKFLOW_LOADED = 'WORKFLOW_LOADED'

const reducer = (state = {}) => ({
  ...state,
  workflowLoaded: true,
})

const workflowLoaded = registerAction(WORKFLOW_LOADED, { reducer })

export default workflowLoaded
